import React, { useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { Messages } from 'src/modules/messages'
import { Profile } from 'src/modules/auth'
import { useActionRunner } from 'src/modules/notification'

import { Admin } from '../modules/admin'
import { Products, useProducts } from '../modules/products'
import { Orders } from '../modules/orders'
import { Invoices } from '../modules/invoices'
import { Customers } from '../modules/customers'

const Routing = () => {
  const {
    fetchAllergenChoices,
    fetchCategoryChoices,
    fetchDietaryChoices,
    fetchNutritionalChoices,
    fetchSustainabilityChoices,
  } = useProducts()

  const [doFetchChoices, isFetching] = useActionRunner(
    [
      fetchAllergenChoices,
      fetchCategoryChoices,
      fetchDietaryChoices,
      fetchNutritionalChoices,
      fetchSustainabilityChoices,
    ],
    {
      initialFetchingState: true,
    }
  )

  useEffect(() => {
    doFetchChoices()
  }, [])

  if (isFetching) {
    return null
  }

  return (
    <>
      <Switch>
        <Route path="/admin" component={Admin} />
        <Route path="/products" component={Products} />{' '}
        <Route path="/orders" component={Orders} />
        <Route path="/invoices" component={Invoices} />
        <Route path="/customers" component={Customers} />
        <Route path="/messages" component={Messages} />
        <Route path="/profile" component={Profile} />
        <Redirect to="/orders" />
      </Switch>
    </>
  )
}

export default Routing
